module.exports = __webpack_public_path__ + "img/logo.b84da6ef.svg";